// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2qQ-I","label":"Labeled_label__1P_97","divider":"Labeled_divider__3pj81"};